/**
 * Google Age Gate: cookie-based verification and redirects.
 * Uses event delegation so buttons work regardless of load order.
 */

const COOKIE_DEFAULT = 'google_age_verified';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, days) {
  const maxAge = days ? days * 24 * 60 * 60 : 365 * 24 * 60 * 60;
  document.cookie = `${name}=1; path=/; max-age=${maxAge}; SameSite=Lax`;
}

function handleGoogleAgeGateClick(e) {
  const confirmBtn = e.target.closest('[data-google-age-gate-confirm]');
  const denyBtn = e.target.closest('[data-google-age-gate-deny]');
  const section = (confirmBtn || denyBtn)?.closest('[data-google-age-gate]');
  if (!section) return;

  const cookieName = section.dataset.cookieName?.trim() || COOKIE_DEFAULT;
  const cookieDays = parseInt(section.dataset.cookieDays?.trim() || '15', 10);
  const redirectUrl = section.dataset.redirectUrl?.trim() || '/';
  const under21Url = section.dataset.under21Url?.trim() || 'https://www.google.com';

  if (confirmBtn) {
    e.preventDefault();
    setCookie(cookieName, cookieDays);
    window.location.href = redirectUrl;
    return;
  }

  if (denyBtn) {
    e.preventDefault();
    window.location.href = under21Url;
  }
}

function init() {
  document.addEventListener('click', handleGoogleAgeGateClick);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
